import { memo } from 'preact/compat';

export type RegionProps = {
	region: SingleRegion;
	pathAttributes?: { [ key: string ]: string };
};

/**
 * Region component. Memo'd to reduce re-renders.
 * Render single region (state) path.
 *
 * @param {Object} props                - component props
 * @param {Object} props.region         - region object from topojson.
 * @param {Object} props.pathAttributes - attributes object for the region to be spread on the path.
 * @return {*} jsx
 */
export const Region = memo( ( {
	region,
	pathAttributes = { className: 'region' },
}: RegionProps ): any => {
	const { id, properties, d } = region;
	const { name } = properties;

	return (
		<path
			d={ d }
			data-id={ id }
			data-region-name={ name }
			{ ...pathAttributes }
		>
			<title>{ name }</title>
		</path>
	);
} );
